import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { FORT_POINT_TYPES, BATTLE_DIRECTIONS } from './constants'

import styles from './FortBattleSeries.scss'


export class FortBattleSeries extends React.Component {

    static propTypes = {
        fortBattleSeries: PropTypes.array.isRequired,
        ownClanId: PropTypes.number.isRequired,
        enemyClanId: PropTypes.number.isRequired,
        isEngagement: PropTypes.bool.isRequired,
    }

    getFortPoints() {
        const { ownClanId, enemyClanId, isEngagement, fortBattleSeries } = this.props
        const length = Object.keys(fortBattleSeries).length
        const isAllItemsCaptured = fortBattleSeries.every(fortPoint => (fortPoint.owner_clan_id === ownClanId))
        const isAllItemsLost = fortBattleSeries.every(fortPoint => (fortPoint.owner_clan_id === enemyClanId))

        return fortBattleSeries.map((fortPoint, index) => {
            const {
                owner_clan_id: ownerClanId,
                attacker_clan_id: attackerClanId,
            } = fortPoint

            const isFirst = (index === 0)
            const isLast = ((index + 1) === length)

            const isAttack = (attackerClanId === ownClanId)
            const isDefense = (attackerClanId === enemyClanId)

            const isOwn = (ownerClanId === ownClanId)
            const isOpponent = (ownerClanId === enemyClanId)

            const type = ((isFirst || isLast) ? FORT_POINT_TYPES.COMMAND_CENTER : FORT_POINT_TYPES.SLOT)

            return {
                isFirst,
                isLast,
                ownerClanId,
                attackerClanId,
                isAttack,
                isDefense,
                isOwn,
                isOpponent,
                type,
            }
        })
        .reduce((pointsAcc, currentPoint, index, initialArray) => {
            const { isFirst, isLast } = currentPoint

            const prevPoint = (isFirst ? null : pointsAcc[pointsAcc.length - 1])
            const nextPoint = (isLast ? null : initialArray[index + 1])

            let battleDirection = null
            if (nextPoint && nextPoint.isAttack) battleDirection = BATTLE_DIRECTIONS.ATTACK
            if (currentPoint.isDefense) battleDirection = BATTLE_DIRECTIONS.DEFENSE

            const isDefeat = (
                (!isEngagement && prevPoint && prevPoint.isDefense) ||
                (isFirst && isAllItemsLost)
            )
            const isVictory = (
                (!isEngagement && nextPoint && nextPoint.isAttack) ||
                (isLast && isAllItemsCaptured)
            )

            return [
                ...pointsAcc,
                {
                    ...currentPoint,
                    battleDirection,
                    isDefeat,
                    isVictory,
                },
            ]
        }, [])
    }

    render() {
        const fortPoints = this.getFortPoints()
        const fortBattleSeriesState = fortPoints.reduce((pointsAcc, fortPoint, index) => {
            const {
                isOwn,
                isOpponent,
                battleDirection,
                isLast,
                isDefeat,
                isVictory,
                type,
            } = fortPoint

            const pointClassName = classNames(styles.point, styles[`point__${type}`])

            const pointIconClassName = classNames(styles.icon, styles[`icon__${type}`], {

                [styles[`icon__${type}-green`]] :
                    isOwn && !isDefeat && !isVictory,

                [styles[`icon__${type}-green-current`]] :
                    isOwn && isVictory,

                [styles[`icon__${type}-red`]] :
                    isOpponent && !isDefeat && !isVictory,

                [styles[`icon__${type}-red-current`]] :
                    isOpponent && isDefeat,

            })

            const point = (
                <span key={`point_${index}`} className={pointClassName}>
                    <span className={pointIconClassName}/>
                </span>
            )

            if (isLast) return [
                ...pointsAcc,
                point,
            ]

            const isLongJoint = ((fortPoints.length / 2 - 1) === index)
            const jointClassName = classNames(styles.joint, {
                [styles.joint__long] : isLongJoint,
            })
            const jointIconClassName = isLongJoint ?

                classNames(styles.icon, styles.icon__joint, {
                    [styles['icon__line-green-long']]: isOwn && (battleDirection === null),
                    [styles['icon__line-red-long']]: isOpponent && (battleDirection === null),
                    [styles[`icon__arrow-${battleDirection}-long`]]: (
                        (battleDirection !== null) && (index !== 2)
                    ),
                    [styles[`icon__arrow-${battleDirection}-long-highlight`]]: (
                        (battleDirection !== null) && (index === 2)
                    ),
                }) :

                classNames(styles.icon, styles.icon__joint, {
                    [styles['icon__line-green-short']] : isOwn && (battleDirection === null),
                    [styles['icon__line-red-short']] : isOpponent && (battleDirection === null),
                    [styles[`icon__arrow-${battleDirection}-short`]] : (battleDirection !== null),
                })

            const joint = (
                <span key={`joint_${index}`} className={jointClassName}>
                    <span className={jointIconClassName}/>
                </span>
            )

            return [
                ...pointsAcc,
                point,
                joint,
            ]

        }, [])

        return (
            <div className={styles.base}>
                {fortBattleSeriesState}
            </div>
        )
    }
}

export default FortBattleSeries



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/FortBattleSeries/FortBattleSeries.jsx